<template>
  <div v-if="hint">
    <div :class="['Hint',{'Hint--info': hint.type === 'info', 'Hint--warning': hint.type === 'warning'}]">
      <span :class="['Hint-icon', {'far fa-info-circle': hint.type === 'info', 'far fa-exclamation-circle': hint.type === 'warning'}]" /> {{ hint.hint }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    hint: {
      type: Object,
      required: false,
      default() {
        return {
          type: '',
          hint: '',
        };
      },
    },
  },
};
</script>
<style type="text/scss" lang="scss">
  .Hint{
    margin: .25rem 0 0;
    font-size: 13px;
    color: color('grey');
  }
  .Hint--warning{
    .Hint-icon{
      color: #ea5b1b;
    }
  }
  .Hint--info{
    .Hint-icon{
      color: #43b5df;
    }
  }
</style>
